document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".knotso-carousel").forEach((carousel) => {

    const track = carousel.querySelector(".knotso-carousel-track");
    const prev = carousel.querySelector(".knotso-carousel-arrow.prev");
    const next = carousel.querySelector(".knotso-carousel-arrow.next");

    if (!track) return;

    const getCardWidth = () => {
      const card = track.querySelector(".knotso-carousel-item");
      if (!card) return 0;

      const gap = parseFloat(getComputedStyle(track).gap) || 0;

      return card.offsetWidth + gap;
    };

    function scrollNext() {
      track.scrollBy({
        left: getCardWidth(),
        behavior: "smooth"
      });
    }

    function scrollPrev() {
      track.scrollBy({
        left: -getCardWidth(),
        behavior: "smooth"
      });
    }

    if (next) {
      next.addEventListener("click", scrollNext);
    }

    if (prev) {
      prev.addEventListener("click", scrollPrev);
    }

    /* ---------- Mouse Drag ---------- */

    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener("mousedown", (e) => {

      isDown = true;

      track.classList.add("dragging");

      startX = e.pageX;

      scrollLeft = track.scrollLeft;

    });

    window.addEventListener("mouseup", () => {

      isDown = false;

      track.classList.remove("dragging");

    });

    track.addEventListener("mouseleave", () => {

      isDown = false;

      track.classList.remove("dragging");

    });

    track.addEventListener("mousemove", (e) => {

      if (!isDown) return;

      e.preventDefault();

      const walk = (e.pageX - startX) * 1.4;

      track.scrollLeft = scrollLeft - walk;

    });

    /* ---------- Auto Scroll ---------- */

    let auto = setInterval(scrollNext, 5000);

    carousel.addEventListener("mouseenter", () => {

      clearInterval(auto);

    });

    carousel.addEventListener("mouseleave", () => {

      auto = setInterval(scrollNext, 5000);

    });

  });

});